
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Merkel_cell_tumor",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Merkel_cell_tumor.vue